<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
--> <template>
  <div>
    <!--  -->
    <mrc_ess_iconGroup :showEdit="false" :show_del="false">
      <mrc_ess_uploadBtn
        type="1"
        :hrefUrl="uploadUrl"
        v-if="btnInterfaceDone"
        class="ml-4"
        v-btnAuth="['upload-staff-template']"
        :label="$t('label_Batch_Import')"
      >
      </mrc_ess_uploadBtn>
      <!-- <v-btn rounded
             tag='a'
             depressed
             height="40"
             v-if="btnInterfaceDone"
             v-btnAuth="['download-staff-template']"
             style="position:relative;"
             class="ml-4"
             :href="uploadUrl"
             color="primary">
        {{$t('label_Download_the_template')}}
      </v-btn> -->
    </mrc_ess_iconGroup>

    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">
          {{ $t("label_Employee_profile") }}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">
          {{ $t("label_addStaff_propety") }}
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1" style="backgroundcolor: #eeeef0">
          <staffdata @changee1="changee1" ref="staffdata"></staffdata>
        </v-stepper-content>

        <v-stepper-content step="2" style="backgroundcolor: #eeeef0">
          <v-card-text>
            <propety
              @changee2="changee2"
              @submit="submit"
              :readonly="true"
              :loading="loading"
              ref="propety"
            >
            </propety>
          </v-card-text>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { USER_INFO_URL } from "@/utils/constant/index.js";
import staffdata from "../modules/staffdata";
import propety from "../modules/propety";
import { add_staff_manager } from "@/service/api/staffPropertyGroup.js";
import {
  uploadFileAll,
  uploadFileUser,
  uploadFileOrg,
} from "@/service/api/upload.js";
import Cookie from "js-cookie";
export default {
  components: {
    staffdata,
    propety,
  },
  data() {
    return {
      uploadUrl: "",
      btnInterfaceDone: false,
      loading: false,
      e1: 1,
      adduserlist: {}, //新增员工基础信息
      file: "",
      staff_property_master_uuid: "",
      mrbase_sys_staff_property: [], //员工属性表
    };
  },
  async created() {
    this.btnInterfaceDone = false;
    await this.getBtnPermissionList();
    this.btnInterfaceDone = true;
    this.uploadUrl = USER_INFO_URL;
  },
  mounted() {
    this.$store.commit("set_uuid", ""); //
  },
  methods: {
    changee1(num, val, val2) {
      this.e1 = num;
      this.adduserlist = val;
      this.file = val2;
    },
    changee2(num) {
      this.e1 = num;
    },
    async submit(val) {
      this.loading = true;
      Array.isArray(this.adduserlist.role_uuids)
        ? (this.adduserlist.role_uuids = this.adduserlist.role_uuids.join())
        : "";
      this.staff_property_master_uuid = val;
      this.mrbase_sys_staff_property = val;
      let login_url = window.location.origin + "/#" + "/login";
      await this.$uploadFiles(this.file, {
          module_uuid:'staff',
          function_uuid: this.$store.state.menuFunctionUuid,
        attachment_data_table: "mrbase_sys_staffs",
        attachment_data_field: "staff_image",
        org_level_uuid: this.$store.state.currentCompany,
        uuid: this.$store.state.currentCompanyClientUuid,
      }).then(async (res) => {
        let urllist = "";
        if (typeof res == "object" && res != undefined && res.code == 200) {
          this.adduserlist.staff_image = res.uuid;
          urllist = res.uuid;
        }
        await add_staff_manager({
          ...this.adduserlist,
          login_url: login_url,
          staff_property_master_uuid: this.staff_property_master_uuid,
        }).then(async (res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            // this.$refs.staffdata.stafflist = {}
            this.$store.commit("set_uuid", ""); //
            this.e1 = 1;
            this.$refs.staffdata.reset();
          } else {
            this.$deleteFile(urllist);
          }
        });
      });
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.v-stepper__content {
  padding: 0px 0px;
}
</style>